import type { KpiPeriodBound } from '@klareospace/pharos-lib-types';
import { KPI_GRANULARITY, KPI_KEYS } from '@klareospace/pharos-lib-types';

import { kpiKeys } from '../api';
import type { OrderKpisTodayScope } from './use-order-kpis-today';
import { useKpiRealtimeSync } from './use-kpi-realtime-sync';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseOrderKpisTodayRealtimeSyncParams {
  bound: Required<KpiPeriodBound>;
  enabled: boolean;
  scope: OrderKpisTodayScope;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Syncs today's cached `order-kpis` KPI and signals page presence — the only KPI hook that registers presence. */
export function useOrderKpisTodayRealtimeSync({ bound, enabled, scope }: UseOrderKpisTodayRealtimeSyncParams): void {
  useKpiRealtimeSync({
    bound,
    enabled,
    granularity: KPI_GRANULARITY.DAY,
    kpiKey: KPI_KEYS.ORDER_KPIS,
    queryKey: kpiKeys.day({ ...bound, ...scope }),
    scope,
    signalPresence: true,
  });
}
